(function() {
    window.c24.lp.ac.bu = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('bu');
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.bu.init();
    });
})();
